module.exports = __webpack_public_path__ + "static/media/Mallory-Book.9da57a7c.woff2";